import { Typography } from "@mui/material";
import { format } from "date-fns";
import { Column, DaysSupply } from "src/api/types";

export const useColumns = (): Column<DaysSupply>[] => {
  return [
    {
      id: "days_supply",
      label: "Days supply",
      align: "center",
      orderable: false,
      minWidth: 80,
      format: (row) => row.days_supply.toString(),
      render: (row) => <Typography>{row.days_supply}</Typography>,
    },
    {
      id: "created_at",
      label: "Created",
      minWidth: 120,
      align: "center",
      orderable: false,
      format: (row) => {
        if (row.created_at == null) {
          return "N/A";
        }

        return format(new Date(row.created_at), "MM/dd/yyyy");
      },
      render: (row) => {
        const createdAt =
          row.created_at == null
            ? "N/A"
            : format(new Date(row.created_at), "MM/dd/yyyy");
        return <Typography>{createdAt}</Typography>;
      },
    },
  ];
};
